import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthService } from './services/auth/auth.service';
import { ApiService } from './http/api.service';
import { HttpTokenInterceptor } from './http/http.token.interceptor';
import { AuthGuard } from './guards/auth.guard';
import { NoAuthGuard } from './guards/no-auth.guard';



@NgModule({
  declarations: [],
  providers:[
    { provide: HTTP_INTERCEPTORS, useClass: HttpTokenInterceptor, multi: true },
    AuthService,
    ApiService,
    AuthGuard,
    NoAuthGuard,
  ],
  imports: [
    CommonModule
  ]
})
export class CoreModule { }
